import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlashService } from './flash.service';

@Injectable({
  providedIn: 'root'
})
export class FormService {

    constructor(private http: HttpClient, private flashService: FlashService) { }

    GetForm(data) {
        return this.http.post('/api/ListGrid/GeneralPage', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    SaveForm(data) {
        return this.http.post('/api/ListGrid/save', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    Picklist(data) {
        return this.http.post('/api/Controls/Picklist', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    private handleSuccess(res) {
        return { success: true, data: res };
    }

    private handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false };
    }
}
